import script from "./FifthSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FifthSection.vue?vue&type=script&setup=true&lang=ts"

import "./FifthSection.vue?vue&type=style&index=0&id=5e8c06a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8c06a2"]])

export default __exports__